export default __webpack_public_path__ + "static/media/Grievous Jamadhar.420f037e.jpg";